import styled, { css } from "styled-components";
import { Tab } from "@renderbus/ui";
import { useGetTabsList } from "./hooks/useTableList";
import { CouponStatus, CouponType } from "./constant";
import {
  TabStoreContainerProvider,
  useTabStore,
} from "@/pages/desktop-coupon/store/tab-store";
import { RenderbusTabsProps } from "@renderbus/ui/components/tab";
import { useNavigate } from "react-router-dom";
import { CouponRules } from "./components/coupon-rules";
import { RenderExchangeModal } from "./components/render-exchange-modal";

export function CouponView() {
  const { tabsList } = useGetTabsList();
  const {
    exchangeModal,
    setExchangeModal,
    setCurrentTab,
    activeKey,
    setActiveKey,
    setCurrentStatus,
    dealCouponsData,
  } = useTabStore();
  const navigate = useNavigate();
  return (
    <CouponWrapper>
      <Tab
        tabsList={tabsList as unknown as RenderbusTabsProps["items"]}
        activeKey={activeKey}
        className="coupon-section-card"
        onChange={(key) => {
          setCurrentStatus(CouponStatus.All);
          setCurrentTab(Number(key) as CouponType);
          setActiveKey(key);
          navigate(`/desktop?activeName=${key}`);
        }}
      />
      <CouponRules />
      <RenderExchangeModal
        modalProps={{
          open: exchangeModal,
          onOk: () => {
            dealCouponsData();
            setExchangeModal(false);
          },
          onCancel: () => {
            setExchangeModal(false);
          },
        }}
      />
    </CouponWrapper>
  );
}

export default function DesktopCoupon() {
  return (
    <TabStoreContainerProvider>
      <CouponView />
    </TabStoreContainerProvider>
  );
}

const CouponSectionCardCSS = css`
  border-radius: 4px;
  border: 1px solid #343538;
`;

const CouponWrapper = styled.div`
  display: flex;
  gap: 11px;
  height: calc(100% - 22px);
  .coupon-section-card {
    ${CouponSectionCardCSS};
  }
`;
